import React from "react";

const YoutubeBlackIcon = () => {
  return (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="18" cy="18" r="18" fill="#379FFF" />
      <path d="M25.6657 14.124C25.4817 13.4311 24.9395 12.8855 24.2511 12.7003C23.0033 12.3638 18 12.3638 18 12.3638C18 12.3638 12.9967 12.3638 11.7489 12.7003C11.0605 12.8855 10.5183 13.4311 10.3343 14.124C10 15.3799 10 18.0001 10 18.0001C10 18.0001 10 20.6204 10.3343 21.8763C10.5183 22.5691 11.0605 23.1148 11.7489 23.3C12.9967 23.6365 18 23.6365 18 23.6365C18 23.6365 23.0033 23.6365 24.2511 23.3C24.9395 23.1148 25.4817 22.5691 25.6657 21.8763C26 20.6204 26 18.0001 26 18.0001C26 18.0001 26 15.3799 25.6657 14.124Z" fill="#0A012E" />
      <path d="M16.3672 20.3791L20.549 18.0002L16.3672 15.6211V20.3791Z" fill="white" />
    </svg>
  );
};

export default YoutubeBlackIcon;
